import { render, staticRenderFns } from "./EmailTemplateEdit.vue?vue&type=template&id=31efe0bd&scoped=true&"
import script from "./EmailTemplateEdit.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmailTemplateEdit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31efe0bd",
  null
  
)

export default component.exports